export default "__VITE_ASSET__C1GX$8gw__"